import { DebouncedFullScreenLoader, FlexiblePlanningNotAvailablePlaceholder } from 'components';
import { useCentreConfiguration, useNavigationContext } from 'hooks';

type Props = { children: React.ReactNode };

export const FlexiblePlanningEnabledFilter = ({ children }: Props) => {
  const { locationId } = useNavigationContext();
  const {
    isIeltsFlexiblePlanningOnCentreEnabled,
    isUkviFlexiblePlanningOnCentreEnabled,
    districtConfigurations,
    isFetching,
  } = useCentreConfiguration();

  if (isFetching) return <DebouncedFullScreenLoader isFetching={isFetching} />;

  const isFlexiblePlanningEnabledInAnyDistrict = districtConfigurations.some(
    (district) => district.isIeltsFlexiblePlanningEnabled || district.isUkviFlexiblePlanningEnabled
  );
  const isDistrictSelected = !!locationId;
  const isFlexiblePlanningEnabledInSelectedDistrict = districtConfigurations.some(
    (district) =>
      district.districtId == locationId &&
      (district.isIeltsFlexiblePlanningEnabled || district.isUkviFlexiblePlanningEnabled)
  );

  const isFlexiblePlanningEnabled =
    isIeltsFlexiblePlanningOnCentreEnabled ||
    isUkviFlexiblePlanningOnCentreEnabled ||
    (isDistrictSelected && isFlexiblePlanningEnabledInSelectedDistrict) ||
    (!isDistrictSelected && isFlexiblePlanningEnabledInAnyDistrict);

  return isFlexiblePlanningEnabled ? children : <FlexiblePlanningNotAvailablePlaceholder />;
};
